var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 383,
    height: 320,
    viewBox: "0 0 383 320",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "logo-path",
    d: "M372.18 136.279H212.982C207.015 136.279 202.193 131.418 202.193 125.451V10.8286C202.193 4.83921 207.037 0 212.982 0H309.868C313.716 0 317.284 2.06155 319.208 5.40343L381.542 120.004C385.693 127.23 380.504 136.257 372.202 136.257L372.18 136.279ZM169.999 0H73.1141C69.2655 0 65.698 2.06155 63.7737 5.40343L1.46106 120.004C-2.69024 127.23 2.49888 136.257 10.8015 136.257H169.999C175.967 136.257 180.788 131.397 180.788 125.429V10.8286C180.788 4.83921 175.945 0 169.999 0ZM202.193 168.57V303.221C202.193 317.804 219.599 325.269 230.107 315.222L375.207 176.403C382.256 169.655 377.499 157.719 367.748 157.719H212.982C207.015 157.719 202.193 162.58 202.193 168.548V168.57ZM7.81772 176.425L152.897 315.07C163.405 325.117 180.81 317.63 180.81 303.069V168.591C180.81 162.602 175.967 157.763 170.021 157.763H15.2771C5.52586 157.763 0.769175 169.698 7.83935 176.447L7.81772 176.425Z",
    fill: "currentColor"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-gradient",
    x1: 10.5204,
    y1: 23.0676,
    x2: 342.436,
    y2: 229.283,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7E3EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#F8C5DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FDB1D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5879"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoIcon);
export default __webpack_public_path__ + "static/media/logo-icon.6e33658383e768e3e4440cd91ffac8af.svg";
export { ForwardRef as ReactComponent };